import { Box, Text } from '@chakra-ui/react';
import React from 'react';

const RegisterLineTr: React.FC<{ borderLeft: string,borderColor:string, title: string, bgColor: string, textColor: string}> = ({borderLeft, title, bgColor, borderColor,textColor}) => {
    return (
        <Box borderColor={borderColor} borderLeft={borderLeft} bg={bgColor} mx='auto'>
            <Text fontSize='13px' fontWeight='600' bg={bgColor} py='13px' px='20px' whiteSpace="nowrap" ml={3} color={textColor}>{title}</Text>                        
        </Box>
    )
}

export default RegisterLineTr;